<template lang="pug">
    // FAQ main information form
    div#quiz-info-view(
      v-if="!isEdit"
      v-loading="processing"
      class="content-border")

      // Title
      el-row
        el-col(:span="24")
          div#content
            p.ql-editor.margin-top-15.padding-right-40(
              v-html="form.description"
            )
            
      // Buttons
      el-row(v-if="isAdminLogin")
        hr#divider
        el-col#buttons(:span="24")
          el-button-group(style="float: right;")
            el-button(
              class="delete-button"
              icon="el-icon-delete"
              @click="deleteFaq")   
                small Erase
            el-button(
              class="primary-button"
              @click="isEdit=true"
              icon="el-icon-edit") 
                small Edit

    div(v-else)
      el-form#quiz-info(
        class="content-border"
        :model="form"
        :rules="rules"
        :disabled="processing"
        ref="formfaq"
        label-position="top"
        v-loading="processing"
      )

        // Description
        el-form-item(prop="description")
          label(:class="$style.label") Description
          rich-editor(
          :maxlength="uiSettings.CONTENT"
            v-model="form.description")

        // Buttons
        el-row
          el-col#buttons(:span="24")
            el-button-group(style="float: right;")
              el-button(
                icon="el-icon-error"
                @click="cancelEdit")   
                  small Cancel
              el-button(
                class="primary-button"
                icon="el-icon-document"
                @click="onSubmitValidate('formfaq')")
                  small Save                  
</template>

<script>
import RichEditor from '@/components/utils/RichEditor'
import utilMixin from '@/components/mixins/utilMixin'
import {MAX_LENGTH} from '@/defines/constants'

export default {
  name: 'FAQInfoView',
  
  components: {
    RichEditor,
  },

  mixins: [utilMixin],

  props: {
    isAdminLogin: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  data() {
    return {
      userData: { 
        userId: this.$store.state.canvasData.userId,
      },
      form: {
        description: '',
      },
      origForm: {
        description: '',
      },
      uiSettings: MAX_LENGTH,

      rules: {
        description: [
          { min: 0, max: MAX_LENGTH.CONTENT,
             message: 'Length should be 0 to ' + MAX_LENGTH.CONTENT, trigger: 'blur' },          
        ],    
      },    
      processing: false,
      isEdit: false,
      hasFaq: false,
    }
  },

  watch: {
    isAdminLogin() {
      if (!this.isAdminLogin) {
        this.isEdit = false
      }
    },
  },

  mounted() {
    this.fetchFaq()
  }, 

  methods: {
    fetchFaq() {
      this.processing = true
      this.axios.get('/api/faqs/home')
        .then((result) => {
          this.processing = false
          this.form = { description: result.data.object.description }
          this.origForm = { description: result.data.object.description }
          this.axios.defaults.headers.common['X-CSRF-TOKEN'] = result.data.csrfToken
          this.$emit('onFaqsLoaded')

          if (this.isAdminLogin) {
            this.isEdit = ( this.form.description.length === 0)
            this.hasFaq = !this.isEdit
          }
        })
        .catch((error) => {
          this.processing = false
          this.mNotification({error: error, message: 'Error fetching Homepage data.'})
        })
    },

    onSubmitValidate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.processing = true
          this.updateFaq({ description: this.form.description, pagename: 'home' })
        } else {
          return false
        }
      })
    },

    updateFaq(config) {
      this.processing = true
      this.axios.post('/api/faqs', config)
        .then((result) => {
          if (result.data.object != undefined ) {
              this.form = result.data.object
              this.origForm = { description: result.data.object.description }
              this.hasFaq = true
              this.mNotification({message: 'Your Homepage has been saved.'})
          }
          this.processing = false
          this.isNew = this.isEdit = false
        })
        .catch((error) => {
          this.processing = false
          this.mNotification({error: error, message: 'Error saving data.'})
        })
    },

    deleteFaq() {
      this.processing = true
      this.axios.delete('/api/faqs')
        .then(() => {
          this.mNotification({message: 'Your Homepage has been reset.'})
          this.form = this.origForm = {}
          this.isEdit = true
          this.hasFaq = false
          this.processing = false
        })
        .catch((error) => {
          this.processing = false
          this.mNotification({error: error, message: 'There was an error deleting the Homepage.'})
        })
    },

    cancelEdit() {
      if (this.hasFaq) {
        this.isEdit = false
        for (let key in this.origForm) {
          this.form[key] = this.origForm[key]
        }
      }
    },
  },
}
</script>

<style module>
  label {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    color: #757575;
  }  

  #buttons {
    margin-top: 10px;
  }

  #title-info {
    color: #303133;
    font-size: 2em;
  }

  #description {
    color: #606266;
    font-size: 14px;
  }

  #buttonpanel {
    position: absolute;
    right: 15px;
    bottom: 20px;
  }

  #content {
    text-align: justify;
    color: #606266;
    margin-top: 2%;
    min-height: 100px;
    padding-bottom: 30px;
  }

  #divider {
    background-color: #DCDFE6;
  }

  .ql-picker-options {
    line-height: 20px;
  }

  .ql-toolbar {
    line-height: 0px;
  }

  .delete-button {
    background-color:#fff;
    color: #ef5350;
    border-color: #ef5350;
    min-width: 100px;
  }

  .delete-button:hover {
    background-color:#ef5350;
    color: #fff;
    border-color: #ef5350;
  }

  .primary-button {
    background-color:#409eff;
    border-color: #409eff;
    color: #fff;
    min-width: 100px;
    margin-left: 10px;
  }

  .primary-button:hover {
    background-color:#66b1ff;
    border-color: #66b1ff;
    color: #fff;
  }

  .normal-button {
    background-color:#fff;
    border-color: #dcdfe6;
    color: #606266;
    min-width: 100px;
  }

  .normal-button:hover {
    background-color:#ecf5ff;
    border-color: #c6e2ff;
    color: #409eff;
  }

  .content-border {
    border: 1px solid #DCDFE6; 
    border-radius: 15px; 
    padding: 15px;
  }
</style>
